import index from './Satellites';

export default index;
